import { useState } from 'react'
import { LinkOutlined } from '@ant-design/icons'
import { message } from 'antd'

import Button from '~/core/Button'

import { quoteDetailsForInviteAndMember_quote as ShareQuoteType } from './__generated__/quoteDetailsForInviteAndMember'
import CopyLinkPopover from './CopyLinkPopover'

type CopyLinkButtonPropsType = {
    placement: string
    quote?: ShareQuoteType | null
    isLocatedInAdminPage?: boolean
    onOpenShare: () => void
    quoteURL: string
    hasError: boolean
    isGenerating: boolean
}

const LINK_COPIED_SECONDS = 2

const CopyLinkButton = (props: CopyLinkButtonPropsType) => {
    const {
        placement,
        isLocatedInAdminPage,
        onOpenShare,
        quoteURL,
        hasError,
        isGenerating,
    } = props
    const [visible, toggleVisible] = useState(false)

    const togglePopover = () => toggleVisible(!visible)

    const onCopied = () => {
        message.success('Link copied!', LINK_COPIED_SECONDS)
    }

    if (quoteURL) {
        return isLocatedInAdminPage ? (
            <CopyLinkPopover
                quoteURL={quoteURL}
                placement={placement}
                onCopied={onCopied}
                togglePopover={togglePopover}
                visible={visible}
                isObo={true}
            >
                <Button
                    placement={placement}
                    name="copy-open-invite-link"
                    data-test-target="copy-open-invite-link"
                >
                    <LinkOutlined /> Copy invitation link
                </Button>
            </CopyLinkPopover>
        ) : (
            <CopyLinkPopover
                onCopied={onCopied}
                placement={placement}
                togglePopover={togglePopover}
                quoteURL={quoteURL}
                visible={visible}
                isObo={false}
            >
                <Button
                    placement={placement}
                    name="copy-open-invite-link"
                    data-test-target="copy-open-invite-link"
                >
                    <LinkOutlined /> Copy invitation link
                </Button>
            </CopyLinkPopover>
        )
    }

    if (hasError) {
        return (
            <Button
                onClick={onOpenShare}
                name="retry-copy-link-button"
                data-test-target="retry-copy-link-button"
                placement={placement}
                style={{ width: '75px' }}
            >
                Retry
            </Button>
        )
    }

    if (isGenerating || (!hasError && !quoteURL)) {
        return (
            <Button
                loading
                disabled
                name="preparing-copy-link-button"
                data-test-target="preparing-copy-link-button"
                placement={placement}
            >
                Preparing Link
            </Button>
        )
    }

    return null
}

export default CopyLinkButton
